import axios from 'axios';
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Loading } from 'element-ui';

const init = function () {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  // Vue.use(ElementUI);
  const vue = new Vue();
  let loading='';
  function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return "";
    }
  }


  // 下面的参数有Authorization
  axios.defaults.headers.common['Authorization'] = "Basic " + getCookie("LoggerToken");
  // https request 拦截器);
  axios.interceptors.request.use(
    (config) => {
      config.cancelToken = source.token;
      // loading=Loading.service({
      //   lock: true,
      //   text: '数据加载中,请稍后...',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(255,255,255,0.5)'
      // });

      return config;
    },
    (err) => {
      const error = err;
      return Promise.reject(error);
    },
  );


  axios.interceptors.response.use(
    (response) => {
      // loading.close();
      let data;
      if (response.data instanceof Object) {
        data = response.data
      } else {
        data = JSON.parse(response.data)
      }
      if (data.status == 101) {
        source.cancel('登录过期,已被弹出');
        if (data.results.url.indexOf('company') > -1) {
          location.href = data.results.url;
        } else {
          vue.$alert('登录验证过期，请重新登录.', '验证过期', {
            showClose: false,
            confirmButtonText:'确定',
            callback: action => {
              location.href="https://www.zjhylab.com/passport/#/login";
              // location.href = data.results.url;
            }
          })
          // return new Promise( ( ) =>{})  //处理101返回抛出异常
        }

      }

      return response
    },
    (error) => {
        // loading.close();
      if (axios.isCancel(error)) {
        console.log('Request canceled', error.message);
      } else {
        console.log(error.response, 'error.response')
        console.log(error, 'error')
        return Promise.reject(error.response)   // 返回接口返回的错误信息
      }

    })

}

export default {
  init
}



// WEBPACK FOOTER //
// ./src/common/request.js